<template>
  <div class="notification-center" ref="rootRef">
    <button
      class="notification-bell"
      :class="{ hasUnread: unreadCount > 0 }"
      @click="open = !open"
      aria-label="通知"
    >
      <span class="bell-icon">🔔</span>
      <span v-if="unreadCount > 0" class="badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </button>
    <div v-if="open" class="notification-dropdown" @click.stop>
      <div class="dropdown-header">
        <span class="dropdown-title">实时通知</span>
        <button
          v-if="unreadCount > 0"
          class="mark-all-btn"
          @click="markAllRead"
        >全部已读</button>
      </div>
      <div class="dropdown-list">
        <div
          v-for="n in notifications"
          :key="n.id"
          class="notification-item"
          :class="{ unread: !n.read }"
        >
          <div class="item-body">
            <div class="item-title">{{ n.title }}</div>
            <div class="item-content">{{ n.content }}</div>
            <div class="item-time">{{ formatTime(n.timestamp) }}</div>
          </div>
          <div class="item-actions">
            <button
              v-if="!n.read"
              class="read-btn"
              @click="markRead(n.id)"
            >已读</button>
            <a
              v-if="n.link"
              class="link-btn"
              @click="goTo(n.link); markRead(n.id)"
            >查看</a>
          </div>
        </div>
        <div v-if="!notifications.length" class="empty-hint">暂无通知</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationCenter',
  data() {
    return {
      open: false
    }
  },
  computed: {
    notifications() {
      return this.$store.state.notifications || []
    },
    unreadCount() {
      return this.$store.getters.unreadNotificationCount || 0
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    formatTime(iso) {
      if (!iso) return ''
      try {
        const d = new Date(iso)
        const now = new Date()
        const diff = now - d
        if (diff < 60000) return '刚刚'
        if (diff < 3600000) return `${Math.floor(diff / 60000)} 分钟前`
        if (diff < 86400000) return `${Math.floor(diff / 3600000)} 小时前`
        return `${d.getMonth() + 1}-${d.getDate()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
      } catch { return '' }
    },
    markRead(id) {
      this.$store.commit('MARK_NOTIFICATION_READ', id)
    },
    markAllRead() {
      this.$store.commit('MARK_ALL_NOTIFICATIONS_READ')
    },
    goTo(link) {
      this.open = false
      if (link && this.$router) {
        this.$router.push(link)
      }
    },
    handleClickOutside(e) {
      if (this.$refs.rootRef && !this.$refs.rootRef.contains(e.target)) {
        this.open = false
      }
    }
  }
}
</script>

<style scoped>
.notification-center {
  position: relative;
}
.notification-bell {
  position: relative;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: rgba(15, 26, 34, 0.06);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}
.notification-bell:hover {
  background: rgba(15, 26, 34, 0.1);
}
.notification-bell.hasUnread {
  background: rgba(234, 84, 85, 0.1);
}
.bell-icon {
  font-size: 18px;
}
.badge {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  background: #ea5455;
  color: white;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notification-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  width: 360px;
  max-height: 420px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.06);
  z-index: 1000;
  display: flex;
  flex-direction: column;
}
.dropdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.dropdown-title {
  font-size: 15px;
  font-weight: 700;
}
.mark-all-btn {
  border: none;
  background: none;
  color: var(--brand);
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;
}
.mark-all-btn:hover {
  text-decoration: underline;
}
.dropdown-list {
  max-height: 360px;
  overflow-y: auto;
}
.notification-item {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  transition: background 0.15s;
}
.notification-item:hover {
  background: rgba(0, 0, 0, 0.02);
}
.notification-item.unread {
  background: rgba(21, 122, 110, 0.04);
}
.notification-item.unread:hover {
  background: rgba(21, 122, 110, 0.08);
}
.item-body {
  flex: 1;
  min-width: 0;
}
.item-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}
.item-content {
  font-size: 13px;
  color: #555;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.item-time {
  font-size: 11px;
  color: var(--muted);
  margin-top: 4px;
}
.item-actions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}
.read-btn, .link-btn {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  border: none;
}
.read-btn {
  background: rgba(21, 122, 110, 0.15);
  color: var(--brand);
}
.link-btn {
  background: rgba(0, 0, 0, 0.06);
  color: #333;
}
.read-btn:hover, .link-btn:hover {
  opacity: 0.9;
}
.empty-hint {
  padding: 32px 16px;
  text-align: center;
  color: var(--muted);
  font-size: 13px;
}
</style>
